<template>
  <div>
    <v-card class="ml-5 mb-5" v-if="checkboxVincular === false">
      <v-card-title class="nav">
        <span class="headline" style="color: white"
          ><v-icon color="white">mdi-account</v-icon> PERFIL</span
        >
      </v-card-title>
      <!-- componente del modal para agregar y actualizar -->
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12 sm6 md6>
              <v-text-field
                v-model="editedItem.cedula"
                label="Cedula"
                mask="#############"
                disabled
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md6>
              <v-text-field
                v-model="editedItem.nombre"
                label="Nombre"
                disabled
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md6>
              <v-text-field
                color="#294697"
                v-model="editedItem.correo"
                :rules="[rules.required, rules.email]"
                label="Correo"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md6>
              <v-text-field
                color="#294697"
                v-model="editedItem.celular"
                label="Celular"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md6>
              <v-autocomplete
                persistent-hint
                v-model="editedItem.idCargo"
                label="Cargo"
                :items="cargos"
                item-value="idCargo"
                item-text="opcion"
                disabled
              ></v-autocomplete>
            </v-flex>
            <v-flex xs12 sm6 md6 v-if="idCargo != 18">
              <v-autocomplete
                color="#294697"
                v-model="editedItem.idZona"
                label="Zona"
                :items="zonas"
                item-text="nombreZona"
                item-value="idZona"
                :rules="[(v) => !!v || 'Se requiere seleccionar una zona']"
                required
              ></v-autocomplete>
            </v-flex>
            <v-flex xs12 sm4 md4>
              <v-select
                item-value="idRol"
                item-text="rol"
                :items="roles"
                label="Rol"
                disabled
                v-model="editedItem.idRol"
              ></v-select>
            </v-flex>
            <v-flex xs12 sm4 md4 v-if="editedItem === ''">
              <v-text-field
                v-model="editedItem.chat_id"
                disabled
                label="SIN VINCULAR TELEGRAM"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm4 md4 v-else>
              <v-row>
                <v-col
                  :cols="editedItem.chat_id === '' ? '12' : '9'"
                  class="mx-0"
                >
                  <v-text-field
                    v-model="editedItem.chat_id"
                    disabled
                    label="Chat ID"
                  ></v-text-field>
                </v-col>
                <v-col
                  v-if="editedItem.chat_id !== ''"
                  cols="3"
                  class="my-auto mx-0"
                >
                  <v-tooltip bottom class="mx-0">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        class="mx-0"
                        @click="dialogTelegram = true"
                        color="#C62828"
                        dark
                        v-bind="attrs"
                        v-on="on"
                      >
                        mdi-delete-forever
                      </v-icon>
                    </template>
                    <span>Desvincular De Telegram</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-flex>

            <v-flex xs12 sm4 md4>
              <v-text-field
                color="#294697"
                v-model="editedItem.contrasena"
                label="Contraseña"
                :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show ? 'text' : 'password'"
                @click:append="show = !show"
              ></v-text-field>
            </v-flex>
            <v-flex
              xs12
              sm6
              md6
              v-if="editedItem.chat_id === '' && isRolAsesor === false"
            >
              <v-checkbox
                v-model="checkboxVincular"
                label="Vincular Telegram"
              ></v-checkbox>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <!-- botones para cancelar y agregregar y validacion de campos vacios -->
      <v-card-actions>
        <span
          v-if="textInformation != ''"
          class="ml-5 body-2 red--text text--accent-1"
          >{{ textInformation }}</span
        >
        <v-spacer></v-spacer>
        <v-btn
          color="#1D3C7F" dark
          @click="save"
          :disabled="
            !editedItem.cedula || !editedItem.nombre || !editedItem.contrasena
          "
          >Guardar</v-btn
        >
      </v-card-actions>
      <v-snackbar
        v-model="snackbar"
        :bottom="y === 'bottom'"
        :left="x === 'left'"
        :multi-line="mode === 'multi-line'"
        :right="x === 'right'"
        :timeout="timeout"
        :top="y === 'top'"
        :vertical="mode === 'vertical'"
        color="#064f8e"
        style="color: black"
      >
        {{ text }}
        <v-btn color="#064f8e" elevation="0" @click="snackbar = false"
          >Cerrar</v-btn
        >
      </v-snackbar>
    </v-card>
    <v-container>
      <v-card v-if="checkboxVincular === true">
        <v-stepper v-model="e1">
          <v-stepper-header>
            <v-stepper-step :complete="e1 > 1" step="1">
              Iniciar proceso
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="e1 > 2" step="2">
              Descarga la aplicacion
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="e1 > 3" step="3">
              Busca y enlaza
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step step="4"> Finalizar </v-stepper-step>
          </v-stepper-header>
          <v-stepper-items>
            <v-stepper-content step="1">
              <v-row class="mb-5 indigo lighten-5 round-lg">
                <v-col cols="4">
                  <v-card
                    class="mb-12 indigo lighten-5"
                    height="300px"
                    elevation="0"
                  >
                    <v-img
                      :src="require('@/assets/ARDILLA.png')"
                      width="380px"
                      class="align-end"
                    >
                    </v-img>
                  </v-card>
                </v-col>
                <v-col cols="8">
                  <v-card elevation="0" class="indigo lighten-5 mt-5 pa-5">
                    <v-card-title dense class="dark--text display-1">
                      <v-icon white class="mr-1 display-2" large>
                        mdi-telegram
                      </v-icon>
                      ENLAZAR PERFIL CON TELEGRAM
                    </v-card-title>
                    <v-card-subtitle
                      class="mt-3 headline font-weight-medium text-decoration-underline"
                    >
                      Vincula tu cuenta por primera vez.
                    </v-card-subtitle>
                    <v-card-text class="text-justify title">
                      Para poder tener la cuenta de Nova vinculada con
                      <v-icon>mdi-telegram</v-icon> Telegram le invitamos a que
                      de click en el boton de
                      <span class="font-weight-bold"> VINCULAR </span>
                      y sigas los pasos que le hiremos indicando, este proceso
                      solo lo debe realizar una vez.
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
              <v-row class="ma-5">
                <v-btn color="primary" @click="e1 = 2"> VINCULAR </v-btn>
                <v-btn text @click="checkboxVincular = false"> Regresar </v-btn>
                <v-spacer></v-spacer>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      color="primary"
                      dark
                      v-bind="attrs"
                      v-on="on"
                      @click="checkboxVincular = false"
                    >
                      mdi-arrow-left-drop-circle-outline
                    </v-icon>
                  </template>
                  <span>VOLVER AL PERFIL</span>
                </v-tooltip>
              </v-row>
            </v-stepper-content>
            <v-stepper-content step="2">
              <v-card elevation="0">
                <v-row>
                  <v-col cols="6">
                    <v-row>
                      <v-col cols="12">
                        <v-card elevation="0">
                          <v-card-text>
                            <div class="font-weight-bold ml-8 mb-2">
                              PROCESO DE INSTALACION
                            </div>

                            <v-timeline align-top dense>
                              <v-timeline-item color="indigo" small>
                                <div>
                                  <div class="font-weight-normal">
                                    <strong>PASO 1</strong>
                                  </div>
                                  <div>
                                    Ingrese a la
                                    <v-icon color="dark " class="mx-2"
                                      >mdi-google-play</v-icon
                                    >
                                    PlayStore desde su dispositivo
                                  </div>
                                </div>
                              </v-timeline-item>
                              <v-timeline-item color="indigo" small>
                                <div>
                                  <div class="font-weight-normal">
                                    <strong>PASO 2</strong>
                                  </div>
                                  <div>
                                    Busque la aplicación de
                                    <v-icon color="dark">mdi-telegram</v-icon>
                                    "TELEGRAM"
                                  </div>
                                </div>
                              </v-timeline-item>
                              <v-timeline-item color="indigo" small>
                                <div>
                                  <div class="font-weight-normal">
                                    <strong>PASO 4</strong>
                                  </div>
                                  <div>
                                    Inicie la instalación, presionando el boton
                                    de instalar.
                                  </div>
                                </div>
                              </v-timeline-item>
                              <v-timeline-item color="indigo" small>
                                <div>
                                  <div class="font-weight-normal">
                                    <strong>PASO 5</strong>
                                  </div>
                                  <div>
                                    Instalada la aplicación se encuenta listo
                                    para enlazar su cuenta.
                                  </div>
                                </div>
                              </v-timeline-item>
                            </v-timeline>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="6" class="rounded">
                    <v-img
                      class="mb-5 image rounded"
                      :src="require('@/assets/logo.png')"
                      contain
                    >
                    </v-img>
                  </v-col>
                </v-row>
              </v-card>
              <v-row class="ma-5">
                <v-btn color="primary" @click="e1 = 3"> APP INSTALADA </v-btn>
                <v-btn text @click="e1 = 1"> regresar </v-btn>
                <v-spacer></v-spacer>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      color="primary"
                      dark
                      v-bind="attrs"
                      v-on="on"
                      @click="checkboxVincular = false"
                    >
                      mdi-arrow-left-drop-circle-outline
                    </v-icon>
                  </template>
                  <span>VOLVER AL PERFIL</span>
                </v-tooltip>
              </v-row>
            </v-stepper-content>
            <v-stepper-content step="3">
              <v-card elevation="0">
                <v-row>
                  <v-col cols="6" class="">
                    <v-img
                      class="mt-5 rounded"
                      :src="require('@/assets/logo.png')"
                      contain
                    >
                    </v-img>
                  </v-col>
                  <v-col cols="6">
                    <v-row>
                      <v-col cols="12">
                        <v-card elevation="0">
                          <v-card-text>
                            <div class="font-weight-bold ml-8 mb-2">
                              PROCESO DE VINCULACION
                            </div>

                            <v-timeline align-top dense>
                              <v-timeline-item color="indigo" small>
                                <div>
                                  <div class="font-weight-normal">
                                    <strong>PASO 1</strong>
                                  </div>
                                  <div>Abra la APP de telegram</div>
                                </div>
                              </v-timeline-item>
                              <v-timeline-item color="indigo" small>
                                <div>
                                  <div class="font-weight-normal">
                                    <strong>PASO 2</strong>
                                  </div>
                                  <div>
                                    En el buscador ingrese la palabra
                                    facivirtual_bot y seleccione el chat.
                                  </div>
                                </div>
                              </v-timeline-item>
                              <v-timeline-item color="indigo" small>
                                <div>
                                  <div class="font-weight-normal">
                                    <strong>PASO 3</strong>
                                  </div>
                                  <div>
                                    Seleccione Iniciar o Start y envie la
                                    palabra Pin (Evite escribirla diferente a
                                    como se muestra aquí).
                                  </div>
                                </div>
                              </v-timeline-item>
                              <v-timeline-item color="indigo" small>
                                <div>
                                  <div class="font-weight-normal">
                                    <strong>PASO 4</strong>
                                  </div>
                                  <div>
                                    Espere a que el bot envie su CHAT ID, este
                                    proceso puede tardar hasta 1 minutos.
                                  </div>
                                </div>
                              </v-timeline-item>
                              <v-timeline-item color="indigo" small>
                                <div>
                                  <div class="font-weight-normal">
                                    <strong>PASO 5</strong>
                                  </div>
                                  <div>
                                    Si ya tiene el codigo, de click en tengo el
                                    codigo.
                                  </div>
                                </div>
                              </v-timeline-item>
                            </v-timeline>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-card>
              <v-row class="ma-5">
                <v-btn color="primary" @click="e1 = 4"> TENGO EL CODIGO </v-btn>
                <v-btn @click="e1 = 2" text> Regresar </v-btn>
                <v-spacer></v-spacer>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      color="primary"
                      dark
                      v-bind="attrs"
                      v-on="on"
                      @click="checkboxVincular = false"
                    >
                      mdi-arrow-left-drop-circle-outline
                    </v-icon>
                  </template>
                  <span class="indigo">VOLVER AL PERFIL</span>
                </v-tooltip>
              </v-row>
            </v-stepper-content>
            <v-stepper-content step="4">
              <v-card elevation="8" class="indigo lighten-5 mb-5">
                <v-card-title
                  style="background: #1b4697"
                  class="white--text mb-5"
                >
                  INGRESE EL CODIGO DE CHAT ID
                </v-card-title>
                <v-card-subtitle class="mt-5">
                  Una vez vinculado el codigo puede gestionar que aplicaciones
                  desea que le envien notificaciones, gracias por realizar este
                  proceso.
                </v-card-subtitle>
                <v-card-actions class="px-5">
                  <v-row>
                    <v-col cols="8">
                      <v-text-field
                        v-model="myChatId"
                        label="CHAT ID"
                        append-icon="mdi-barcode-scan"
                        outlined
                        dense
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="4" class="">
                      <v-btn
                        block
                        color="#1b4697"
                        class="white--text"
                        @click="updateCode"
                        :disabled="!myChatId"
                      >
                        Enviar
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-actions>
              </v-card>
              <v-row class="ma-5">
                <v-btn text @click="e1 = 3"> Regresar </v-btn>
                <v-spacer></v-spacer>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      color="primary"
                      dark
                      v-bind="attrs"
                      v-on="on"
                      @click="checkboxVincular = false"
                    >
                      mdi-arrow-left-drop-circle-outline
                    </v-icon>
                  </template>
                  <span>VOLVER AL PERFIL</span>
                </v-tooltip>
              </v-row>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-card>
    </v-container>
    <audio v-if="estado == 1" autoplay loop>
      <source src="../../assets/alerta-sonido.mp3" type="audio/mp3" />
    </audio>
    <v-dialog fullscreen v-model="alertDialog" persistent>
      <v-card
        color="rgba(255,0,0,0.4)"
        style="display: flex; align-items: center; justify-content: center"
      >
        <div
          style="
            border: 5px solid white;
            display: flex;
            align-items: center;
            flex-direction: column;
            justify-content: center;
            height: 550px;
            width: 550px;
            color: white;
            background-color: red;
            font-size: 2em;
            padding: 1em;
          "
        >
          <img
            class="mb-7 mr-8"
            src="../../assets/warning.gif"
            style="height: 200px; width: 200px"
            alt=""
          />
          <p>se activo la alarma de <strong>¡PANICO!</strong></p>
          <p><strong>ip: </strong>{{ ipActual }}</p>
          <p><strong>municipio: </strong>{{ municipioActual }}</p>
          <p><strong>punto: </strong>{{ puntoActual }}</p>
          <v-btn style="height: 3em; width: 5em" @click="parar()">ok</v-btn>
        </div>
      </v-card>
    </v-dialog>
    <!-- Dialog para confirmar desvinculacion de telegram -->
    <v-dialog v-model="dialogTelegram" persistent max-width="450">
      <v-card>
        <v-card-title class="headline">
          Esta a punto de desvincular telegram de su cuenta.
        </v-card-title>
        <v-card-text
          >Para volver a vincular solo debe seguir los pasos de vinculacion.
          ¿Esta seguro en continuar con este proceso?.</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-3" text @click="dialogTelegram = false">
            Cerrar
          </v-btn>
          <v-btn color="red darken-4" text @click="removeTelegram">
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import env from "../env";
export default {
  data() {
    return {
      id: localStorage.getItem("id"),
      idCargo: localStorage.getItem("idCargo"),
      e1: 1,
      dialogTelegram: false,
      dialog1: false,
      alertDialog: false,
      textInformation: "",
      show: false,
      isRolAsesor: true,
      snackbar: false,
      y: "top",
      x: null,
      mode: "",
      timeout: 6000,
      text: "",
      search: "",
      estado: 0,
      ipActual: "",
      idPanico: "",
      municipioActual: "",
      puntoActual: "",
      idActual: "",
      usuario: [],
      areas: [],
      roles: [],
      alertas: [],
      cargos: [],
      chatId: "",
      myChatId: "",
      messagePasswordConfirm: "",
      checkboxVincular: false,
      rules: {
        required: (value) => !!value || "Required.",
        counter: (value) => value.length <= 20 || "Maximo 20 characteres",
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalido e-mail.";
        },
      },
      defaultItem: {
        idUsuario: "",
        nombre: "",
        cedula: "",
        contrasena: "",
        idArea: "",
        idRol: "",
        correo: "",
        celular: "",
        idCargo: "",
        /* fechaI:"",
        fechaN:"", */
      },
      userModified: {},
      editedItem: {
        idUsuario: "",
        nombre: "",
        cedula: "",
        contrasena: "",
        idArea: "",
        idRol: "",
        correo: "",
        celular: "",
        idCargo: "",
        chat_id: "",
      },
      zonas: [],
    };
  },

  computed: {},
  // computed: {
  //   isPasswordValid() {
  //     // Validar que la contraseña no sea igual a la cédula
  //     if (this.editedItem.contrasena === this.editedItem.cedula) {
  //       return false;
  //     }
      
  //     // Validar que la contraseña no contenga la cédula
  //     if (this.editedItem.contrasena.includes(this.editedItem.cedula)) {
  //       return false;
  //     }

      // Validar longitud mínima
      // if (this.editedItem.contrasena.length < 8) {
      //   return false;
      // }
  // }


  mounted() {
    this.obtenerTodo();
    this.obtenerUsuarios();
    this.editItem();
    this.obtenerApps();
    this.obtenerZonas();
    // 🆕 Funcionalidad de pánico deshabilitada - ya no se necesita
    // this.panico();
    // if (this.idCargo == "15" || this.idCargo == "29") {
    //   setInterval(() => {
    //     this.panico();
    //   }, 10000);
    // }
  },

  methods: {
    // Metodo para obtener las alertas
    // 🆕 Funcionalidad deshabilitada - ya no se necesita
    panico() {
      // Funcionalidad deshabilitada
      return;
      // axios.get(`${env.endpoint}callcenter/panico`).then((res) => {
      //   this.alertas = res.data;
      //   res.data.map((item) => {
      //     item.estado === "1" ? this.confirmacion(item) : null;
      //   });
      // });
    },
    parar() {
      this.estado = 0;
      this.dialog1 = false;
      axios
        .get(
          `${env.endpoint}callcenter/panicoAtencion?idPanico=${this.idPanico}`
        )
        .then((res) => (this.report = res.data));
      this.$router.push("/User/Panico");
    },
    //metodo para abrir modal de alerta
    confirmacion(alerta) {
      this.estado = alerta.estado;
      this.ipActual = alerta.ip;
      this.idPanico = alerta.idPanico;
      this.municipioActual = alerta.municipio;
      this.puntoActual = alerta.punto;
      this.idActual = alerta.idPanico;

      if (this.estado === "1") {
        this.alertDialog = true;
        //console.log("alerta");
      }
    },
    removeTelegram() {
      const usuario = JSON.stringify({
        idUsuario: this.editedItem.idUsuario,
        nombre: this.editedItem.nombre,
        cedula: this.editedItem.cedula,
        contrasena: this.editedItem.contrasena,
        idArea: this.editedItem.idArea,
        idRol: this.editedItem.idRol,
        correo: this.editedItem.correo,
        celular: this.editedItem.celular,
        idCargo: this.editedItem.idCargo,
        idZona: this.editedItem.idZona,
        chat_id: "",
      });

      axios
        .get(`${env.endpoint}user/modificar_user?usuario=${usuario}`)
        .then((res) => {
          if (res.data.mensaje === "usuario actualizado") {
            (this.snackbar = true),
              (this.text = "Chat ID desvinculado satisfactoriamente");
          } else if (res.data.mensaje === "error en la actualizacion") {
            (this.snackbar = true), (this.text = "Error en la actualización");
          }
          this.obtenerTodo();
          this.obtenerUsuarios();
        });
      this.dialogTelegram = false;
    },
    //Metodo para obtener las app a las que esta enlazado el usuario y validar si puede vincular su cuenta con telegram
    obtenerApps() {
      this.isRolAsesor = true;
      axios
        .get(`${env.endpoint}user/permisosUser?id=${this.idCargo}`)
        .then((res) => {
          res.data.forEach((enabledApplication) => {
            if (
              enabledApplication.nombreApp === "CALLCENTER" &&
              enabledApplication.rol === "especialista"
            ) {
              this.isRolAsesor = false;
            }
          });
        });
    },
    // Metodo para obtener los usuarios
    obtenerUsuarios() {
      axios.get(`${env.endpoint}user/usuarios`).then((res) => {
        res.data.forEach((user) => {
          if (user.idUsuario === this.id) {
            this.editedItem = user;
            this.userModified = user;
            this.chatID = this.editedItem.chat_id;
          }
        });
      });
    },
    /**
     * Metodo para actualizar un usuario por primera vez que genera codigo en telegram
     */
    updateCode() {
      const usuario = JSON.stringify({
        idUsuario: this.editedItem.idUsuario,
        nombre: this.editedItem.nombre,
        cedula: this.editedItem.cedula,
        contrasena: this.editedItem.contrasena,
        idArea: this.editedItem.idArea,
        idRol: this.editedItem.idRol,
        correo: this.editedItem.correo,
        celular: this.editedItem.celular,
        idCargo: this.editedItem.idCargo,
        idZona: this.editedItem.idZona,
        chat_id: this.myChatId,
      });
      // se seta los datos obtenidos del arreglo par modificarlo
      axios
        .get(`${env.endpoint}user/modificar_user?usuario=${usuario}`)
        .then((res) => {
          if (res.data.mensaje === "usuario actualizado") {
            this.myChatId = "";
            this.text =
              "El codigo ha sido cargado exitosamente, ahora telegram se encuentra vinculado con NOVA.";
            this.snackbar = true;
            this.checkboxVincular = false;
            this.obtenerTodo();
            this.obtenerUsuarios();
          } else if (res.data.mensaje === "error en la actualizacion") {
            this.text =
              "Error en el envio del codigo, comuniquise con el area de sistemas si el problema persiste";
            this.snackbar = true;
            this.myChatId = "";
          }
        })
        .catch((error) => {
          this.myChatId = "";
          this.text =
            "Ha ocurrido un error en el sistema, intentelo más tarde, si el problema persiste comuniquese con el area de sistemas. ";
          this.snackbar = true;
        });
    },
    /**
     * Metodo para obtener roles y areas
     */
    obtenerTodo() {
      axios
        .get(`${env.endpoint}user/rol`)
        .then((res) => (this.roles = res.data));
      axios.get(`${env.endpoint}user/cargos`).then((res) => {
        for (let index = 0; index < res.data.length; index++) {
          res.data[index].opcion =
            res.data[index].nombreCargo +
            " (" +
            res.data[index].cc_nombre_area +
            ")";
        }
        this.cargos = res.data;
      });
    },
    /**
     * Metodo para obtener las zonas
     */
    obtenerZonas() {
      axios.get(`${env.endpoint}user/consultarZonas`).then((res) => {
        this.zonas = res.data;
      });
    },
    /**
     * Metodo para agregar fila de la tabla en la modal
     */
    editItem() {
      this.editedItem = Object.assign({}, this.editedItem);
    },

    /**
     * Metodo para cerrar la modal
     */
    close() {
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.editedItem);
      }, 300);
    },

    /**
     * Metodo para guardar y actualizar
     */
    save() {

      if (!this.isPasswordValid) {
        if (this.editedItem.contrasena === this.editedItem.cedula) {
          this.snackbar = true;
          this.text = "La contraseña no puede ser igual a su número de cédula";
          this.editedItem.contrasena = "";
          return;
        }
        
        if (this.editedItem.contrasena.includes(this.editedItem.cedula)) {
          this.snackbar = true;
          this.text = "La contraseña no puede contener su número de cédula";
          this.editedItem.contrasena = "";
          return;
        }

        // if (this.editedItem.contrasena.length < 8) {
        //   this.snackbar = true;
        //   this.text = "La contraseña debe tener al menos 8 caracteres";
        //   this.editedItem.contrasena = "";
        //   return;
        // }
      // if (this.editedItem.contrasena.length >= 8) {
      //   var mayuscula = true;
      //   var minuscula = true;
      //   var numero = true;
      //   var caracter_raro = true;

      //   for (var i = 0; i < this.editedItem.contrasena.length; i++) {
      //     if (
      //       this.editedItem.contrasena.charCodeAt(i) >= 65 &&
      //       this.editedItem.contrasena.charCodeAt(i) <= 90
      //     ) {
      //       mayuscula = true;
      //     } else if (
      //       this.editedItem.contrasena.charCodeAt(i) >= 97 &&
      //       this.editedItem.contrasena.charCodeAt(i) <= 122
      //     ) {
      //       minuscula = true;
      //     } else if (
      //       this.editedItem.contrasena.charCodeAt(i) >= 48 &&
      //       this.editedItem.contrasena.charCodeAt(i) <= 57
      //     ) {
      //       numero = true;
      //     } else {
      //       caracter_raro = true;
      //     }
      //   }
      //   if (
      //     mayuscula == true &&
      //     minuscula == true &&
      //     caracter_raro == true &&
      //     numero == true
      //   ) {
      const usuario = JSON.stringify({
        idUsuario: this.editedItem.idUsuario,
        nombre: this.editedItem.nombre,
        cedula: this.editedItem.cedula,
        contrasena: this.editedItem.contrasena,
        idArea: this.editedItem.idArea,
        idRol: this.editedItem.idRol,
        correo: this.editedItem.correo,
        celular: this.editedItem.celular,
        idCargo: this.editedItem.idCargo,
        chat_id: this.editedItem.chat_id,
        idZona: this.editedItem.idZona,
        vinculado: this.editedItem.vinculado,
      });
      axios
        .get(`${env.endpoint}user/modificar_user?usuario=${usuario}`)
        .then((res) => {
          //console.log(res.data);
          if (res.data.mensaje === "usuario actualizado") {
            (this.snackbar = true),
              (this.text = "usuario actualizado satisfactoriamente");
          } else if (res.data.mensaje === "error en la actualizacion") {
            (this.snackbar = true), (this.text = "Error en la actualización");
          }
          this.obtenerTodo();
          this.obtenerUsuarios();
        });
      //   } else {
      //     var text = "Debe contener";
      //     if (!mayuscula) {
      //       text = text + " Minimo 1 mayúscula  -  ";
      //     }
      //     if (!minuscula) {
      //       text = text + "  - Minimo 1 minuscula";
      //     }
      //     if (!caracter_raro) {
      //       text = text + " - Minimo 1 caracter especial";
      //     }
      //     if (!numero) {
      //       text = text + " - Minimo 1 número ";
      //     }
      //     this.text = text;
      //     this.snackbar = true;
      //     // if (!mayuscula) {
      //     //   (this.snackbar = true), (this.text = "Minimo 1 mayúscula");
      //     //   this.editedItem.contrasena = "";
      //     // } else {
      //     //   if (!minuscula) {
      //     //     (this.snackbar = true), (this.text = "Minimo 1 minúscula");
      //     //     this.editedItem.contrasena = "";
      //     //   } else {
      //     //     if (!caracter_raro) {
      //     //       (this.snackbar = true),
      //     //         (this.text = "Minimo 1 caracter especial");
      //     //       this.editedItem.contrasena = "";
      //     //     } else {
      //     //       (this.snackbar = true), (this.text = "Minimo 1 número");
      //     //       this.editedItem.contrasena = "";
      //     //     }
      //     //   }
      //     // }
      //   } // obtiene los datos del arreglo para poder actualizar el usuario en el modal
      // } else {
      //   (this.snackbar = true), (this.text = "Contraseña minimo 8 caracteres");
      //   this.editedItem.contrasena = "";
      // }
      }
    },
  },
};
</script>
<style scoped>
.image {
  opacity: 0.8 !important;
}
</style>
